const convertListToIdObject = (list = [], idKey = 'id') =>
  list.reduce((acc, element) => ({ ...acc, [element[idKey]]: element }), {});

export default convertListToIdObject;
